<template>
  <AdminModal :title="`Editar usuario · ${user.name || user.email}`" @close="$emit('close')">
    <form @submit.prevent="submit">
      <div class="ad-field">
        <label for="eu-name">Nombre</label>
        <input id="eu-name" v-model="name" class="ad-input" autocomplete="off" />
      </div>
      <div class="ad-field">
        <label for="eu-email">Correo de acceso</label>
        <input id="eu-email" v-model="email" type="email" class="ad-input" autocomplete="off" />
      </div>
      <p v-if="emailChanged && active" class="ad-note ad-note--danger">
        Esta cuenta ya está activa. Conserva su contraseña, pero se cerrarán sus sesiones y se avisará al correo anterior y al nuevo.
      </p>
      <p v-else-if="emailChanged" class="ad-note">
        La cuenta aún no se activa: se generará una invitación nueva y se enviará al correo nuevo. La anterior deja de funcionar.
      </p>
      <div v-if="emailChanged && active" class="ad-field">
        <label for="eu-pass">Tu contraseña de superadmin</label>
        <input id="eu-pass" v-model="password" type="password" class="ad-input" autocomplete="current-password" />
      </div>
    </form>
    <p v-if="error" class="ad-error">{{ error }}</p>
    <template #footer>
      <button type="button" class="ad-btn ad-btn--ghost" @click="$emit('close')">Cancelar</button>
      <button type="button" class="ad-btn ad-btn--primary" :disabled="!canSave" @click="submit">{{ busy ? 'Guardando…' : 'Guardar cambios' }}</button>
    </template>
  </AdminModal>
</template>

<script setup>
import { ref, computed } from 'vue'
import AdminModal from './AdminModal.vue'
import { updateUser } from '@/services/superadmin'
import { errorText } from './adminFormat'

const props = defineProps({ user: { type: Object, required: true } })
const emit = defineEmits(['close', 'done'])

const name = ref(props.user.name || '')
const email = ref(props.user.email)
const password = ref('')
const busy = ref(false)
const error = ref('')

// Una cuenta "activa" es la que ya creó su contraseña (cualquier estado menos PENDING).
const active = computed(() => props.user.status !== 'PENDING')
const emailChanged = computed(() => email.value.trim().toLowerCase() !== props.user.email.toLowerCase())
const nameChanged = computed(() => name.value.trim() !== (props.user.name || ''))
const canSave = computed(() => !busy.value && (emailChanged.value || nameChanged.value) && (!emailChanged.value || !active.value || !!password.value))

async function submit() {
  if (!canSave.value) return
  busy.value = true
  error.value = ''
  try {
    const body = {}
    if (nameChanged.value) body.name = name.value.trim()
    if (emailChanged.value) body.email = email.value.trim()
    if (emailChanged.value && active.value) body.password = password.value
    const res = await updateUser(props.user.kind, props.user.id, body)
    emit('done', res)
  } catch (err) {
    error.value = errorText(err)
    busy.value = false
  }
}
</script>